<template>
  <v-card class="mb-1" elevation="0">
    <v-row class="align-center">
      <v-col cols="10">
        <p v-if="currentVersion">
          <strong>Versão atual -</strong> Será substituída pela nova versão
        </p>
        <p v-else><strong>Nova versão -</strong> Editada por você</p>
      </v-col>
      <v-col cols="2" class="d-flex justify-end mb-2">
        <v-btn @click="$emit('open')" elevation="0">
          <v-icon color="#ee8e51">
            mdi-tag-outline
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    currentVersion: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light {
  &.v-btn.v-btn--has-bg {
    background-color: transparent !important;
    border: 1px solid #ee8e51;

    width: 44px !important;
    min-width: 44px !important;
    height: 44px !important;
  }
}
</style>
